import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import cssVars from '../_variables.scss.js';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import hashTemplates from './hashTemplates.js';
import { columnCountFromTemplate, minifyTemplate } from './templates.js';
import { columnCountFromBreakpoint } from './breakpoints.js';
import parseTemplatesToComponents from './parseTemplatesToComponents.js';
import extrapolateProps from './extrapolateProps.js';
import styles from './styles.scss.js';

var Grid = function Grid(_a) {
  var _b;

  var className = _a.className,
      wrapperClassName = _a.wrapperClassName,
      _c = _a.margins,
      margins = _c === void 0 ? true : _c,
      _d = _a.rowGaps,
      rowGaps = _d === void 0 ? false : _d,
      rest = __rest(_a, ["className", "wrapperClassName", "margins", "rowGaps"]);

  return React.createElement("div", {
    className: classnames(styles.wrapper, wrapperClassName)
  }, React.createElement("div", __assign({
    className: classnames(className, styles.grid, (_b = {}, _b[styles.gridMargins] = margins, _b[styles.gridRowGaps] = rowGaps, _b))
  }, rest)));
};

var ResponsiveGrid = function ResponsiveGrid(_a) {
  var style = _a.style,
      className = _a.className,
      children = _a.children,
      rest = __rest(_a, ["style", "className", "children"]);

  var responsiveAreasPropNames = ['areas', 'areasXs', 'areasSm', 'areasMd', 'areasLg', 'areasXlg', 'areasXxlg'];
  var responsiveAreaProps = pick(rest, responsiveAreasPropNames);
  var passthroughProps = omit(rest, responsiveAreasPropNames);
  var extrapolatedAreasProps = extrapolateProps(rest); // Build a map of { breakpoint: template } for all provided area templates

  var allTemplates = {};

  for (var _i = 0, _b = Object.entries(responsiveAreaProps); _i < _b.length; _i++) {
    var _c = _b[_i],
        areaPropName = _c[0],
        areaTemplate = _c[1];

    if (areaTemplate) {
      var breakpointName = areaPropName.slice(5).toLowerCase() || 'default';
      allTemplates[breakpointName] = areaTemplate;
    }
  } // Generate a unique ID for this grid


  var gridHash = hashTemplates(allTemplates);
  var cssBlocks = [];
  responsiveAreasPropNames.forEach(function (propName) {
    // "areasXs" => "xs"
    var breakpointName = propName.slice(5).toLowerCase() || null; // "areasXs" => "xs"
    // "xs"  => "360px"

    var breakpointSize = cssVars["breakpoint-" + breakpointName] || undefined; // The template value for this breakpoint: "a a b b" "c c c c"

    var templateAreas = extrapolatedAreasProps[propName];

    if (templateAreas) {
      var expectedColumns = columnCountFromBreakpoint(breakpointName);
      var templatedColumns = columnCountFromTemplate(templateAreas);

      if (expectedColumns !== templatedColumns) {
        throw new Error("Expected the \"" + propName + "\" template to have " + expectedColumns + " columns, but found " + templatedColumns + ": " + templateAreas);
      }

      var cssRule = ".grid-" + gridHash + " { grid-template-areas: " + minifyTemplate(templateAreas) + " }";
      var mediaQueryFeatures = [];

      if (breakpointSize) {
        mediaQueryFeatures.push("(min-width: " + breakpointSize + ")");
        cssBlocks.push("@media " + mediaQueryFeatures.join(' and ') + " { " + cssRule + " }");
      } else {
        cssBlocks.push(cssRule);
      }
    }
  });
  return React.createElement(React.Fragment, null, cssBlocks.length > 0 && React.createElement("style", {
    type: "text/css",
    dangerouslySetInnerHTML: {
      __html: cssBlocks.join('\n')
    }
  }), React.createElement(Grid, __assign({
    className: classnames(className, "grid-" + gridHash)
  }, passthroughProps), typeof children === 'function' ? children(parseTemplatesToComponents(allTemplates, gridHash)) : children));
};

export default ResponsiveGrid;
//# sourceMappingURL=index.js.map
